// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__1gIIy","header":"PatientBlock_header__2_wKa","label":"PatientBlock_label__36zl1","option":"PatientBlock_option__eQ2k7"};